import { render } from "./RequirementCard.vue?vue&type=template&id=6b9231d8&scoped=true"
import script from "./RequirementCard.vue?vue&type=script&lang=js"
export * from "./RequirementCard.vue?vue&type=script&lang=js"

import "./RequirementCard.vue?vue&type=style&index=0&id=6b9231d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9231d8"]])

export default __exports__